import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Stack,
  Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useTranslation } from 'react-i18next'
import { MonthlyInternalHours } from '@/types'
import { HrEmployeeWeekSection } from './HrEmployeeWeekSection'

type Props = {
  month: MonthlyInternalHours
}

export const HrEmployeeMonthAccordion = ({ month }: Props): JSX.Element => {
  const { t } = useTranslation('hrInternalHours')

  return (
    <Accordion variant="outlined" disableGutters={true}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" alignItems="center" spacing={3} width="100%">
          <Typography variant="subtitle1" fontWeight="bold" sx={{ flex: 1 }}>
            {month.month_label}
          </Typography>
          <Typography
            variant="body2"
            color="secondary.main"
            fontWeight="bold"
            sx={{ mr: 2 }}
          >
            {t('detail.month.totalHours', { hours: month.total_hours })}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={3} divider={<Divider />}>
          {month.weeks.map((week) => (
            <HrEmployeeWeekSection key={week.week_number} week={week} />
          ))}
          {month.weeks.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              {t('detail.month.noWeeks')}
            </Typography>
          )}
        </Stack>
      </AccordionDetails>
    </Accordion>
  )
}
